import React from 'react';
import { connect } from 'react-redux';
import Header from '../../components/template/Header';
import Footer from '../../components/template/Footer';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { addEcs } from '../../store/actions/ecss_action';
import { TextInput, TextArea } from '../../components/Form/Form';

const DonateCalam = ({ addEcs }) => {
  return (
    <div>
      <Header active='CONTACT_US' />
      <section className='main-cause pb-50'>
        <div className='container'>
          <div className='stic'>
            <div className='row'>
              <div className='col-md-7'>
                <h3 className='details'>Donation Details</h3>
                <div className='donation-form'>
                  <Formik
                    initialValues={{
                      name: '',
                      email: '',
                      phone: '',
                    }}
                    validationSchema={Yup.object({
                      name: Yup.string().required('Required'),
                      email: Yup.string().required('Required'),
                      phone: Yup.string().required('Required'),
                    })}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {
                      setSubmitting(true);
                      // values.referrer = document.referrer;
                      await addEcs(values);
                      resetForm();
                      setSubmitting(false);
                      window.location.href = `/thank-you`;
                    }}
                  >
                    {(formik) => {
                      console.log(formik);
                      return (
                        <Form>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <TextInput
                                  label='Name'
                                  name='name'
                                  type='text'
                                  placeholder='Enter Name'
                                />
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <TextInput
                                  label='Email'
                                  name='email'
                                  type='text'
                                  placeholder='Enter Email'
                                />
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group'>
                                <TextInput
                                  label='Phone'
                                  name='phone'
                                  type='text'
                                  placeholder='Enter Phone'
                                />
                              </div>
                            </div>
                            <div className='donate-button'>
                              <button className='btn btn-donate'>
                                Submit Now
                              </button>
                            </div>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                  <hr />
                  <div className='bank-details'>
                    <h3>
                      Our Bank details to make donation from net-banking /
                      Internet Banking.
                    </h3>
                    {/* <div className='main-details'>
                      <h3>ICICI Bank Details</h3>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Beneficiary Name</div>
                        <div className='value'>
                          National Organisation for Social Empowerment
                        </div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Types Of Account</div>
                        <div className='value'>Current</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Account Number</div>
                        <div className='value'>032205001782</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Branch</div>
                        <div className='value'>
                          SAFDARJUNG ENCLAVE, NEW DELHI 110029
                        </div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Branch Code</div>
                        <div className='value'>000322</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>IFSC Code</div>
                        <div className='value'>ICIC0000322</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>MICR Code</div>
                        <div className='value'>110229044</div>
                      </div>
                    </div>
                    <hr />
                    <div className='main-details'>
                      <h3>ICICI Bank Details</h3>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Beneficiary Name</div>
                        <div className='value'>
                          National Organisation for Social Empowerment
                        </div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Types Of Account</div>
                        <div className='value'>Current</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Account Number</div>
                        <div className='value'>032205001782</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Branch</div>
                        <div className='value'>
                          SAFDARJUNG ENCLAVE, NEW DELHI 110029
                        </div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Branch Code</div>
                        <div className='value'>000322</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>IFSC Code</div>
                        <div className='value'>ICIC0000322</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>MICR Code</div>
                        <div className='value'>110229044</div>
                      </div>
                    </div> */}
                    {/* <div className='main-details'>
                      <h3>HDFC Bank Details</h3>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Beneficiary Name</div>
                        <div className='value'>
                          National Organisation for Social Empowerment
                        </div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Types Of Account</div>
                        <div className='value'>Current</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Account Number</div>
                        <div className='value'> 50200011770584</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Branch</div>
                        <div className='value'>Zamrudpur New Delhi-110048</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Branch Code</div>
                        <div className='value'>004108</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>IFSC Code</div>
                        <div className='value'>HDFC0004108</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>MICR Code</div>
                        <div className='value'>110240386</div>
                      </div>
                    </div> */}
                    <div className='main-details'>
                      <h3> IndusInd Bank Details</h3>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Beneficiary Name</div>
                        <div className='value'>
                          National Organisation for Social Empowerment
                        </div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Types Of Account</div>
                        <div className='value'>Current</div>
                      </div>
                      <hr />
                      <div className='account-flex'>
                        <div className='name'>Account Number</div>
                        <div className='value'> 100263742805</div>
                      </div>
                      <hr />

                      <div className='account-flex'>
                        <div className='name'>IFSC Code</div>
                        <div className='value'>INDB0000160</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-5'>
                <div className='sidebar'>
                  <h3>You Are Donation Towards</h3>
                  <div className='banner-ei'>
                    <div className='main-image'>
                      <img src='assets/images/22811264.jpg' />
                    </div>
                    <div id='home' className='main-content'>
                      <div className='#home'>
                        <h2>
                          Thank you for showing us that we are not alone in our
                          mission!
                        </h2>
                        <p>
                          We are grateful for your thoughtfulness while poor
                          migrant workers are going through this difficult time.
                          Because of your kind support, we have fed more than 4
                          lakhs poor people across Delhi/NCR.
                        </p>
                        <p>
                          Your generosity and support during this difficult time
                          is greatly appreciated!
                        </p>
                        <p>
                          So far we have fed more than <b>4, 00,000 people</b>{' '}
                          in Delhi/NCR by consistently providing hygienic cooked
                          meals without any failure every day. The best part of
                          the <b>Food Distribution Drive</b> of the
                          <b>National Organisation For Social Empowerment</b> is
                          that we are going door to door. We had given needy
                          people freshly cooked food packets every day and
                          during the distribution procedure our NGO followed the
                          social distancing and lockdown norms.
                        </p>
                        <p>
                          While immediate food relief is a concern, so is
                          safety. It is to lessen the impact of the crisis on
                          these sections of the society, and to ensure their
                          access to essentials, that
                          <b>
                            National Organisation For Social Empowerment
                          </b>{' '}
                          aka
                          <b>National NGO</b> are sending out appeals for funds.
                        </p>
                        <div className='share'>
                          <button className='btn btn-share'>
                            <i className='fa fa-facebook' /> Share On Facebook
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { addEcs };

export default connect(mapStateToProps, mapDispatchToProps)(DonateCalam);
